import N8nPagination from './Pagination.vue';

export default N8nPagination;
export { N8nPagination };
export type * from './Pagination.types';
